import { ITooltipAngularComp } from '@ag-grid-community/angular';
import { ITooltipParams } from '@ag-grid-community/core';
import { ChangeDetectorRef, Component } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { GridColumn } from '../../grid.types';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'tt-grid-html-tooltip',
    templateUrl: './grid-html-tooltip.component.html',
    styleUrls: ['./grid-html-tooltip.component.css'],
})
export class GridHtmlTooltipComponent extends ComponentBaseComponent implements ITooltipAngularComp {
    public text: SafeHtml = '';

    constructor(
        private datatask: DataTaskService,
        private sanitizer: DomSanitizer,
        private cdr: ChangeDetectorRef,
    ) {
        super();
    }

    private async loadHTMLContent(datataskKeyno: number, data: any) {
        if (!!data) {
            let { isbase64, html } = await this.getHTMLContent(datataskKeyno, data);

            if (isbase64 === '1') {
                try {
                    html = this.base64UrlDecode(html);
                } catch (error) {
                    console.error(error);
                    html = '';
                }
            }

            this.text = this.sanitizer.bypassSecurityTrustHtml(html);

            this.cdr.markForCheck();
        }
    }

    private loadContentFromScript(script: string, data: any) {
        if (!!script && typeof script === 'string' && !!data) {
            try {
                this.text = new Function('row', script).call(this, data);
                this.cdr.markForCheck();
            } catch (error) {
                console.error(error);
            }
        }
    }

    private async getHTMLContent(datataskKeyno: number, data: any): Promise<{ isbase64: '1' | '0'; html: string }> {
        return (await this.datatask.Post(datataskKeyno, data))[0];
    }

    public agInit(params: ITooltipParams<any, any, any> & { tt_column: GridColumn }): void {
        if (params.location === 'header' && !!params.value) {
            this.text = this.sanitizer.bypassSecurityTrustHtml(params.value);
            this.cdr.markForCheck();
        } else if (!!params.tt_column.tooltip_datatask && !isNaN(+params.tt_column.tooltip_datatask)) {
            this.loadHTMLContent(+params.tt_column.tooltip_datatask, params.data);
        } else if (!!params.tt_column.tooltip_script) {
            this.loadContentFromScript(params.tt_column.tooltip_script, params.data);
        }
    }
}
